import React from 'react';
import Styled from 'styled';
import classnames from 'classnames';

import defaultStyles from './textarea.scss';

export interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    styles: typeof defaultStyles;
    actions?: React.ReactNode;
    attachments?: React.ReactNode;
    setTextarea?: (ref: HTMLTextAreaElement) => void;
}

interface State {
    panelAtBottom: boolean;
    overflow?: string;
    height?: number;
}

class Textarea extends React.PureComponent<Props, State> {
    state: State = {
        panelAtBottom: this.props.attachments != null,
    };

    container = React.createRef<HTMLDivElement>();
    widthGhost = React.createRef<HTMLDivElement>();
    heightGhost = React.createRef<HTMLDivElement>();
    actions = React.createRef<HTMLDivElement>();

    render() {
        const { styles, actions, attachments, setTextarea, ...rest } = this.props;
        const { panelAtBottom, overflow, height } = this.state;

        let style: React.CSSProperties | undefined;

        if (height) {
            style = {
                height,
            };

            if (overflow) {
                style = {
                    ...style,
                    overflow,
                };
            }
        }

        return (
            <div
                ref={this.container}
                className={classnames(styles.container, {
                    [styles.panelAtBottom]: panelAtBottom,
                    [styles.hasAttachments]: attachments != null,
                })}
            >
                <div ref={this.widthGhost} className={styles.widthGhost}>
                    {rest.value}
                </div>
                <div ref={this.heightGhost} className={styles.heightGhost}>
                    {rest.value}
                </div>
                <textarea {...rest} ref={setTextarea} className={styles.textarea} style={style} />
                <div className={styles.panel}>
                    {attachments}
                    <div className={styles.actions} ref={this.actions}>
                        {actions || null}
                    </div>
                </div>
            </div>
        );
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.value !== prevProps.value || this.props.attachments !== prevProps.attachments) {
            if (this.container.current && this.widthGhost.current && this.actions.current && this.heightGhost.current) {
                const overflow =
                    this.heightGhost.current.scrollHeight !== this.heightGhost.current.clientHeight
                        ? 'auto'
                        : undefined;

                this.setState({
                    overflow,
                    height: this.heightGhost.current.clientHeight,
                    panelAtBottom:
                        overflow !== undefined ||
                        this.props.attachments != null ||
                        this.widthGhost.current.clientWidth + this.actions.current.clientWidth >=
                            this.container.current.clientWidth,
                });
            }
        }
    }
}

export default Styled(defaultStyles)(Textarea);
